export default __webpack_public_path__ + "static/media/text.6ec25da2.png";